import React, { useEffect, useState } from "react";
import "./ImagePage.css";
import Response from "../data/response";
import { Link, useParams } from "react-router-dom";
import imagePage__logo from "../assets/googlelogo_color_272x92dp.png";
import Search from "./Search";
import SearchIcon from "@material-ui/icons/Search";
import DescriptionIcon from "@material-ui/icons/Description";
import ImageIcon from "@material-ui/icons/Image";
import LocalOfferIcon from "@material-ui/icons/LocalOffer";
import RoomIcon from "@material-ui/icons/Room";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import useGoogleSearch from "../hooks/useGoogleSearch";

function SearchPage() {
  const { q } = useParams();
  const [term, setTerm] = useState("");

  // LIVE API CALL
  const { data } = useGoogleSearch(q);

  // MOCK API CALL
//   const data = Response;

  useEffect(() => {
    if (q !== undefined && q !== "undefined" && q !== null) {
      setTerm(q);
    }
  }, [q]);

  return (
    <div className="imagePage">
      <header className="imagePage__header">
        <Link to="/">
          <img className="imagePage__logo" src={imagePage__logo} alt="logo" />
        </Link>
        <div className="imagePage__headerBody">
          <Search hideButtons />
          <div className="imagePage__options">
            <div className="imagePage__optionsLeft">
              <div className="imagePage__option">
                <SearchIcon />
                <Link to={`/search/${q || term}`}>All</Link>
              </div>
              <div className="imagePage__option">
                <DescriptionIcon />
                <Link to={window.location}>News</Link>
              </div>
              <div className="imagePage__option">
                <ImageIcon />
                <Link to={`/images/${q || term}`}>Images</Link>
              </div>
              <div className="imagePage__option">
                <LocalOfferIcon />
                <Link to={window.location}>Shopping</Link>
              </div>
              <div className="imagePage__option">
                <RoomIcon />
                <Link to={window.location}>Maps</Link>
              </div>
              <div className="imagePage__option">
                <MoreVertIcon />
                <Link to={window.location}>More</Link>
              </div>
            </div>
            <div className="imagePage__optionsRight">
              <div className="imagePage__option">
                <Link to={window.location}>Settings</Link>
              </div>
              <div className="imagePage__option">
                <Link to={window.location}>Tools</Link>
              </div>
            </div>
          </div>
        </div>
      </header>
      {q && (
        <main className="imagePage__results">
          <p className="imagePage__resultCount">
            About {data?.searchInformation.formattedTotalResults} results (
            {data?.searchInformation.formattedSearchTime} seconds) for {q}
          </p>
          <div className="imagePage__resultsImage">
            {data?.items.map((item) => (
              <div className="imagePage__result">
                {item.pagemap.cse_image[0].src !== "undefined" ? (
                  <img src={item.pagemap.cse_image[0].src} loading="lazy" />
                ) : (
                  <div />
                )}
              </div>
            ))}
          </div>
        </main>
      )}
    </div>
  );
}

export default SearchPage;
